import { useGestaoTreinamentosCadastroViewModel } from "../../viewModels/gestao_treinamentos_cadastro_view_model";
import { Breadcrumbs, Typography, Link, Stack } from "@mui/material";
import { BackButton } from "../../../../../common/components/back_button";
import { CadastroTreinamentoModal } from "./components/cadastro_treinamento_modal";
import { AvaliarTreinamentoModal } from "./components/avaliar_treinamento_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { TabTreinamentosContent } from "./components/tab_treinamentos_content";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";



export const GestaoTreinamentosTercCadastro = () => {
  const viewModel = useGestaoTreinamentosCadastroViewModel();

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <BackButton
              onClick={viewModel.handleBack}
            />
          }
        />
      </PageTopBar>

      <div className="PAGE flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Terceirização
          </Link>
          <Typography className="text-primary-green">
            Gestão de Treinamentos
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Gestão de Treinamentos</h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className="flex flex-row gap-2"></div>
        </div>

        {
          viewModel.errorMessage
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReloadPage} />
              </div>
            ) : (
              <Stack spacing={0} className="mt-4">
                <TabTreinamentosContent
                  loading={viewModel.loading}
                  onPageChange={viewModel.handlePageChange}
                  onRowsPerPageChange={viewModel.handleRowsPerPageChange}
                  treinamentosPage={viewModel.pagination.page}
                  treinamentosRowsPerPage={viewModel.pagination.rowsPerPage}
                  treinamentosTotalItems={viewModel.pagination.totalItems}
                  treinamentosLista={viewModel.funcionarioTreinamentos}
                  onCadastrar={viewModel.handleCadastroFuncionarioTreinamentoOpenState}
                  onAvaliar={viewModel.handleAvaliarFuncionarioTreinamentoOpenState}
                  onAvaliarLote={viewModel.handleAvaliarLoteTreinamentoOpenState}
                  onExportar={viewModel.handleReportFuncionarioTreinamento}
                  onEditar={viewModel.handleEditarFuncionarioTreinamento}
                  onDeletar={viewModel.handleDeletarFuncionarioTreinamentoOpenState}
                  onDeletarLote={viewModel.handleDeletarTreinamentosLoteOpenState} />

              </Stack>
            )
        }

        <CadastroTreinamentoModal
          open={viewModel.openCadastroFuncionarioTreinamentoModal}
          saving={viewModel.saving}
          selectedTreinamento={viewModel.selectedFuncionarioTreinamento}
          treinamentoLista={viewModel.filters.treinamentoLista ?? []}
          onSubmit={viewModel.handleSubmitTreinamento}
          onClose={viewModel.handleCadastroFuncionarioTreinamentoOpenState}
          onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

        <AvaliarTreinamentoModal
          open={viewModel.openAvaliarFuncionarioTreinamentoModal}
          saving={viewModel.saving}
          selectedTreinamento={viewModel.selectedFuncionarioTreinamento ?? null}
          onSubmit={viewModel.handleSubmitAvaliarTreinamento}
          onClose={viewModel.handleAvaliarFuncionarioTreinamentoOpenState} />


        <DeleteDialog
          open={viewModel.openDeletarFuncionarioTreinamentoModal}
          saving={viewModel.saving}
          onClose={() => viewModel.handleDeletarFuncionarioTreinamentoOpenState(null, false)}
          title={`Você realmente deseja excluir o treinamento selecionado?`}
          onDelete={() => viewModel.handleConfirmarDeletarFuncionarioTreinamento()} />

        <ReportViewerModal
          reportViewerState={viewModel.reportViewerState}
        />
        <ChangeHistoryModal
          changeHistoryHandler={viewModel.changeHistory}
        />


      </div>
    </>
  );
}